import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InitSystemTypeState, SystemTypeState } from './SystemTypeReducer';

export const selectSystemType = createFeatureSelector<SystemTypeState>('systemType');

export const initSystemTypeSelector = createSelector(
  selectSystemType,
  InitSystemTypeState
);
